module.exports = __webpack_public_path__ + "img/HK.7d72c1f4.svg";